import React, { Component } from "react";
import { Form } from "react-bootstrap";
import "./index.css";
import api from '../../../services/client';
import { Redirect } from "react-router-dom";
import routes from "../../routes";
import { ToastContainer, toast } from 'react-toastify';

export default class Company extends Component {
  companyForm;

  handleOnSubmit = async (e) => {
    e.preventDefault();
    var formData = new FormData(e.target),
      formDataObj = Object.fromEntries(formData.entries());
      formDataObj.Username = formDataObj.FirstName + ' ' + formDataObj.LastName;
      formDataObj.UserType = 3;

    const data = await api.register(formDataObj).then((data) => {
        toast("Company register successfully");
        return data.status;
     })
    .catch(error => {
        toast("Company or Email already registered");
        return error;
    });
    data == '200' && e.target.reset();
  };
  render() {
    return (
      <>
        <Form
          ref={(ins) => {
            this.companyForm = ins;
          }}
          onSubmit={this.handleOnSubmit.bind(this)}
        >
          <Form.Group className="mb-3" controlId="formFirstName">
            <Form.Control
              type="text"
              placeholder="First Name"
              name="FirstName"
              required
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formLastName">
            <Form.Control type="test" placeholder="Last Name" name="LastName" required />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formCompanyName">
            <Form.Control
              type="text"
              placeholder="Company Name"
              name="CompanyName"
              required
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Control type="email" placeholder="Enter email" name="Email" required/>
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Control
              type="password"
              placeholder="Password"
              name="Password"
              required
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="companyFormSubmit">
            <Form.Control type="submit" style={{ display: "none" }} />
          </Form.Group>
          <div className="signText">
          <Form.Check
            type={"checkbox"}
            required
            label={`I have read, understood and agree to the Intellutual Point terms of service, including the User Agreement and Privacy policy`}
          />
        </div>
        </Form>

        
        <ToastContainer position="bottom-right" autoClose={2000} closeOnClick theme='colored'  />
      </>
    );
  }
}
